/* VALERO — offres groupées, compte à rebours, livraison, WhatsApp, avant/après,
   FAQ, carrousels (flèches, points, défilement auto), vidéos clients, barre de
   commande collante, guide des tailles, apparitions au défilement. Aucune dépendance. */
(function () {
  'use strict';

  var JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  var MOIS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
  var reduireAnimations = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Argent : reproduit le format monétaire de la boutique ── */
  function grouper(entier, sep) {
    return String(entier).replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }
  function argent(centimes) {
    var format = window.VL_MONEY_FORMAT || window.NT_MONEY_FORMAT || '{{amount_no_decimals_with_space_separator}} FCFA';
    var c = Math.round(Number(centimes) || 0);
    function deci(sepMilliers, sepDecimal) {
      var parts = (c / 100).toFixed(2).split('.');
      return grouper(parts[0], sepMilliers) + sepDecimal + parts[1];
    }
    function sans(sepMilliers) { return grouper(Math.round(c / 100), sepMilliers); }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, cle) {
      switch (cle) {
        case 'amount': return deci(',', '.');
        case 'amount_no_decimals': return sans(',');
        case 'amount_with_comma_separator': return deci('.', ',');
        case 'amount_no_decimals_with_comma_separator': return sans('.');
        case 'amount_with_space_separator': return deci(' ', ',');
        case 'amount_no_decimals_with_space_separator': return sans(' ');
        case 'amount_with_apostrophe_separator': return deci("'", '.');
        default: return sans(' ');
      }
    });
  }

  /* ── Contexte produit ── */
  function formulaire() {
    return document.getElementById('nt-product-form') || document.querySelector('form[action*="/cart/add"]');
  }
  function variantes() {
    var el = document.querySelector('[data-vl-variantes]');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }
  function varianteCourante() {
    var liste = variantes();
    var f = formulaire();
    var champ = f && f.querySelector('[name="id"]');
    var id = champ ? String(champ.value) : '';
    if (liste[id]) return liste[id];
    var cles = Object.keys(liste);
    return cles.length ? liste[cles[0]] : null;
  }
  function quantite() {
    var f = formulaire();
    var champ = f && f.querySelector('[name="quantity"]');
    var q = champ ? parseInt(champ.value, 10) : 1;
    return q > 0 ? q : 1;
  }
  function definirQuantite(q) {
    var f = formulaire();
    if (!f) return;
    f.querySelectorAll('[name="quantity"]').forEach(function (champ) {
      champ.value = q;
      champ.dispatchEvent(new Event('input', { bubbles: true }));
      champ.dispatchEvent(new Event('change', { bubbles: true }));
    });
    document.dispatchEvent(new CustomEvent('vl:quantite', { detail: { quantite: q } }));
  }

  /* ── Offres groupées ── */
  function initOffres(racine) {
    if (racine.dataset.vlPret) return;
    racine.dataset.vlPret = '1';
    var remisesActives = racine.dataset.remises === '1';
    var offres = Array.prototype.slice.call(racine.querySelectorAll('.vl-offre'));

    function rafraichir() {
      var v = varianteCourante();
      if (!v) return;
      offres.forEach(function (o) {
        var q = parseInt(o.dataset.qte, 10) || 1;
        var r = remisesActives ? (parseInt(o.dataset.remise, 10) || 0) : 0;
        var total = Math.floor(v.p * q * (100 - r) / 100);
        var reference = (v.c > v.p ? v.c : v.p) * q;
        var eco = reference - total;
        o.querySelector('[data-vl-total]').textContent = argent(total);
        var barre = o.querySelector('[data-vl-barre]');
        barre.textContent = argent(reference);
        barre.hidden = !(reference > total);
        var sous = o.querySelector('[data-vl-sous]');
        if (eco > 0) {
          sous.textContent = 'Vous économisez ' + argent(eco);
          sous.classList.add('vl-offre__sous--eco');
        } else {
          sous.textContent = q === 1 ? 'Prix normal' : argent(v.p) + ' l’unité';
          sous.classList.remove('vl-offre__sous--eco');
        }
      });
    }

    function choisir(o, focus) {
      offres.forEach(function (x) {
        var actif = x === o;
        x.setAttribute('aria-checked', actif ? 'true' : 'false');
        x.tabIndex = actif ? 0 : -1;
      });
      if (focus) o.focus();
      definirQuantite(parseInt(o.dataset.qte, 10) || 1);
    }

    offres.forEach(function (o, i) {
      o.addEventListener('click', function () { choisir(o, false); });
      o.addEventListener('keydown', function (e) {
        var dir = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : (e.key === 'ArrowUp' || e.key === 'ArrowLeft') ? -1 : 0;
        if (!dir) return;
        e.preventDefault();
        choisir(offres[(i + dir + offres.length) % offres.length], true);
      });
    });

    var initiale = offres.filter(function (o) { return o.getAttribute('aria-checked') === 'true'; })[0] || offres[0];
    if (initiale) choisir(initiale, false);
    rafraichir();
    document.addEventListener('change', function () { setTimeout(rafraichir, 60); });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.nt-product-info__options, .nt-option-pills')) setTimeout(rafraichir, 80);
    });
  }

  /* ── Compte à rebours (date réelle fixée par la boutique) ── */
  function initCompte(racine) {
    if (racine.dataset.vlPret) return;
    racine.dataset.vlPret = '1';
    var brut = (racine.dataset.fin || '').trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(brut)) brut += 'T23:59';
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(brut)) brut += ':00';
    if (!/[zZ]|[+-]\d{2}:\d{2}$/.test(brut)) brut += 'Z'; /* Abidjan = GMT */
    var fin = Date.parse(brut);
    if (isNaN(fin) || fin <= Date.now()) { racine.hidden = true; return; }
    var champs = {
      j: racine.querySelector('[data-u="j"]'),
      h: racine.querySelector('[data-u="h"]'),
      m: racine.querySelector('[data-u="m"]'),
      s: racine.querySelector('[data-u="s"]')
    };
    function deux(n) { return (n < 10 ? '0' : '') + n; }
    var minuteur;
    function tic() {
      var reste = Math.max(0, fin - Date.now());
      if (reste <= 0) { racine.hidden = true; clearInterval(minuteur); return; }
      var s = Math.floor(reste / 1000);
      champs.j.textContent = deux(Math.floor(s / 86400));
      champs.h.textContent = deux(Math.floor(s % 86400 / 3600));
      champs.m.textContent = deux(Math.floor(s % 3600 / 60));
      champs.s.textContent = deux(s % 60);
    }
    racine.hidden = false;
    minuteur = setInterval(tic, 1000);
    tic();
  }

  /* ── Estimation de livraison (heure d'Abidjan = GMT, dimanches exclus) ── */
  function ajouterJoursOuvres(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) {
      d.setUTCDate(d.getUTCDate() + 1);
      if (d.getUTCDay() !== 0) n--;
    }
    return d;
  }
  function jourTexte(d) {
    return JOURS[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + MOIS[d.getUTCMonth()];
  }
  function initLivraison(racine) {
    if (racine.dataset.vlPret) return;
    racine.dataset.vlPret = '1';
    var limite = parseInt(racine.dataset.limite, 10) || 14;
    var dAbj = parseInt(racine.dataset.abidjan, 10);
    var dMin = parseInt(racine.dataset.min, 10) || 2;
    var dMax = Math.max(dMin, parseInt(racine.dataset.max, 10) || dMin);
    if (isNaN(dAbj)) dAbj = 1;
    var maintenant = new Date();
    var envoi = new Date(maintenant.getTime());
    var tard = maintenant.getUTCHours() >= limite || maintenant.getUTCDay() === 0;
    if (tard) envoi = ajouterJoursOuvres(maintenant, 1);
    var livraisonAbj = dAbj === 0 ? envoi : ajouterJoursOuvres(envoi, dAbj);
    var intMin = ajouterJoursOuvres(envoi, dMin);
    var intMax = ajouterJoursOuvres(envoi, dMax);
    function ecrire(cle, texte) {
      var el = racine.querySelector('[data-vl-date="' + cle + '"]');
      if (el) el.textContent = texte;
    }
    ecrire('commande', "Aujourd'hui");
    ecrire('envoi', tard ? jourTexte(envoi) : "Aujourd'hui");
    ecrire('livraison', jourTexte(livraisonAbj));
    ecrire('abidjan', jourTexte(livraisonAbj));
    ecrire('interieur', dMin === dMax ? jourTexte(intMin) : 'entre ' + jourTexte(intMin) + ' et ' + jourTexte(intMax));
    var titre = racine.querySelector('[data-vl-limite-texte]');
    if (titre) {
      titre.textContent = tard
        ? 'Commandez maintenant : votre colis part ' + jourTexte(envoi)
        : 'Commandez avant ' + limite + ' h : votre colis part aujourd’hui';
    }
  }

  /* ── Commande WhatsApp ── */
  function initWhatsapp(lien) {
    if (lien.dataset.vlPret) return;
    lien.dataset.vlPret = '1';
    function construire() {
      var v = varianteCourante();
      var modele = lien.dataset.message || 'Bonjour, je souhaite commander : {produit} ({variante}) x {quantite}. {lien}';
      var variante = v && v.t && v.t !== 'Default Title' ? v.t : '';
      var texte = modele
        .replace(/\{produit\}/g, lien.dataset.produit || '')
        .replace(/\{variante\}/g, variante)
        .replace(/\{quantite\}/g, String(quantite()))
        .replace(/\{lien\}/g, lien.dataset.lien || window.location.href)
        .replace(/\(\s*\)/g, '')
        .replace(/\s{2,}/g, ' ')
        .trim();
      lien.href = 'https://wa.me/' + lien.dataset.numero + '?text=' + encodeURIComponent(texte);
    }
    construire();
    lien.addEventListener('click', construire);
    lien.addEventListener('focus', construire);
    lien.addEventListener('mouseenter', construire);
    document.addEventListener('vl:quantite', construire);
  }

  /* ── Avant / après ── */
  function initAvantApres(racine) {
    if (racine.dataset.vlPret) return;
    racine.dataset.vlPret = '1';
    var curseur = racine.querySelector('.vl-aa__curseur');
    if (!curseur) return;
    function maj() { racine.style.setProperty('--pos', curseur.value + '%'); }
    curseur.addEventListener('input', maj);
    maj();
  }

  /* ── FAQ / onglets : une seule réponse ouverte à la fois ── */
  function initFaq(racine) {
    if (racine.dataset.vlPret) return;
    racine.dataset.vlPret = '1';
    var items = racine.querySelectorAll('details');
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (autre) { if (autre !== d) autre.open = false; });
      });
    });
  }

  /* ── Carrousels : flèches, points de pagination, défilement automatique ── */
  function icoFleche() {
    return '<svg class="vl-ico" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  }
  function initCarrousel(racine) {
    if (racine.dataset.vlPret) return;
    racine.dataset.vlPret = '1';
    var piste = racine.querySelector('.vl-carrousel__piste');
    var prec = racine.querySelector('.vl-carrousel__fleche--prec');
    var suiv = racine.querySelector('.vl-carrousel__fleche--suiv');
    if (!piste) return;
    var points = null;
    var auto = parseInt(racine.dataset.vlAuto, 10) || 0;
    var minuterie = null;

    function largeurElement() {
      var premier = piste.firstElementChild;
      var gap = parseFloat(getComputedStyle(piste).columnGap || getComputedStyle(piste).gap) || 16;
      return premier ? premier.getBoundingClientRect().width + gap : piste.clientWidth;
    }
    function parVue() { return Math.max(1, Math.round(piste.clientWidth / largeurElement())); }
    function nbPages() { return Math.max(1, Math.ceil(piste.children.length / parVue())); }
    function pageCourante() {
      var max = piste.scrollWidth - piste.clientWidth;
      if (max > 0 && piste.scrollLeft >= max - 4) return nbPages() - 1;
      return Math.round(piste.scrollLeft / (largeurElement() * parVue()));
    }
    function allerPage(p) {
      piste.scrollTo({ left: p * largeurElement() * parVue(), behavior: reduireAnimations ? 'auto' : 'smooth' });
    }
    function construirePoints() {
      if (!racine.hasAttribute('data-vl-points')) return;
      if (!points) {
        points = document.createElement('div');
        points.className = 'vl-carrousel__points';
        racine.appendChild(points);
      }
      var n = nbPages();
      points.innerHTML = '';
      points.hidden = n < 2;
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Aller à la page ' + (i + 1));
        (function (idx) { b.addEventListener('click', function () { allerPage(idx); relancer(); }); })(i);
        points.appendChild(b);
      }
    }
    function etat() {
      var max = piste.scrollWidth - piste.clientWidth - 2;
      if (prec) prec.disabled = piste.scrollLeft <= 2;
      if (suiv) suiv.disabled = piste.scrollLeft >= max;
      if (points) {
        var p = pageCourante();
        Array.prototype.forEach.call(points.children, function (b, i) { b.setAttribute('aria-current', i === p ? 'true' : 'false'); });
      }
    }
    function suivant() {
      var p = pageCourante() + 1;
      allerPage(p >= nbPages() ? 0 : p);
    }
    function relancer() {
      if (!auto || reduireAnimations) return;
      clearInterval(minuterie);
      minuterie = setInterval(suivant, auto * 1000);
    }
    if (prec) prec.addEventListener('click', function () { piste.scrollBy({ left: -largeurElement(), behavior: reduireAnimations ? 'auto' : 'smooth' }); relancer(); });
    if (suiv) suiv.addEventListener('click', function () { piste.scrollBy({ left: largeurElement(), behavior: reduireAnimations ? 'auto' : 'smooth' }); relancer(); });
    piste.addEventListener('scroll', function () { window.requestAnimationFrame(etat); }, { passive: true });
    piste.addEventListener('pointerdown', function () { clearInterval(minuterie); });
    racine.addEventListener('mouseenter', function () { clearInterval(minuterie); });
    racine.addEventListener('mouseleave', relancer);
    window.addEventListener('resize', function () { construirePoints(); etat(); });
    construirePoints();
    etat();
    relancer();
  }

  /* Le carrousel d'avis existant (section NT — Avis clients) reçoit flèches et points */
  function ameliorerAvis(portee) {
    (portee || document).querySelectorAll('.nt-reviews--carrousel .nt-reviews__list').forEach(function (liste) {
      if (liste.closest('.vl-carrousel')) return;
      var enveloppe = document.createElement('div');
      enveloppe.className = 'vl-carrousel vl-carrousel--3 vl-carrousel--avis';
      enveloppe.setAttribute('data-vl-carrousel', '');
      enveloppe.setAttribute('data-vl-points', '');
      enveloppe.setAttribute('data-vl-auto', '6');
      liste.parentNode.insertBefore(enveloppe, liste);
      enveloppe.appendChild(liste);
      liste.classList.add('vl-carrousel__piste');
      var p = document.createElement('button');
      p.type = 'button'; p.className = 'vl-carrousel__fleche vl-carrousel__fleche--prec'; p.setAttribute('aria-label', 'Avis précédents'); p.innerHTML = icoFleche();
      var s = document.createElement('button');
      s.type = 'button'; s.className = 'vl-carrousel__fleche vl-carrousel__fleche--suiv'; s.setAttribute('aria-label', 'Avis suivants'); s.innerHTML = icoFleche();
      enveloppe.insertBefore(p, liste);
      enveloppe.appendChild(s);
      var aide = enveloppe.parentNode.querySelector('.nt-reviews__hint');
      if (aide) aide.hidden = true;
    });
  }

  /* ── Vidéos clients : lecture muette quand elles sont à l'écran ── */
  var observateurVideo = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entrees) {
    entrees.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting && !reduireAnimations) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else v.pause();
    });
  }, { threshold: 0.5 }) : null;
  function initVideo(carte) {
    if (carte.dataset.vlPret) return;
    carte.dataset.vlPret = '1';
    var v = carte.querySelector('video');
    var bouton = carte.querySelector('.vl-video-carte__son');
    if (!v) return;
    v.muted = true;
    if (observateurVideo) observateurVideo.observe(v);
    if (bouton) bouton.addEventListener('click', function () {
      v.muted = !v.muted;
      if (!v.muted) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      bouton.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
      bouton.setAttribute('aria-label', v.muted ? 'Activer le son' : 'Couper le son');
    });
  }

  /* ── Barre de commande collante ── */
  function initBarre(barre) {
    if (barre.dataset.vlPret) return;
    barre.dataset.vlPret = '1';
    var bouton = barre.querySelector('[data-vl-barre-cible]');
    function cible() {
      return document.querySelector('.es-form-container:not(.upsell-modal-content)') || document.querySelector('.es-css') || formulaire() || document.querySelector('.nt-product-info');
    }
    if (bouton) bouton.addEventListener('click', function (e) {
      e.preventDefault();
      var c = cible();
      if (c) c.scrollIntoView({ behavior: reduireAnimations ? 'auto' : 'smooth', block: 'center' });
    });
    var info = document.querySelector('.nt-product-info');
    function maj() {
      var c = cible();
      var ref = c || info;
      if (!ref) return;
      var r = ref.getBoundingClientRect();
      var visible = r.bottom < 0 || r.top > window.innerHeight;
      var pied = document.querySelector('.vl-pied, .nt-footer');
      if (pied && pied.getBoundingClientRect().top < window.innerHeight) visible = false;
      barre.classList.toggle('est-visible', visible && window.scrollY > 400);
      barre.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }
    window.addEventListener('scroll', function () { window.requestAnimationFrame(maj); }, { passive: true });
    maj();
  }

  /* ── Fenêtres (guide des tailles) ── */
  function initDialogues(portee) {
    (portee || document).querySelectorAll('[data-vl-dialog-ouvrir]').forEach(function (bouton) {
      if (bouton.dataset.vlPret) return;
      bouton.dataset.vlPret = '1';
      bouton.addEventListener('click', function () {
        var d = document.getElementById(bouton.getAttribute('data-vl-dialog-ouvrir'));
        if (!d) return;
        if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
      });
    });
    (portee || document).querySelectorAll('dialog.vl-dialog').forEach(function (d) {
      if (d.dataset.vlPret) return;
      d.dataset.vlPret = '1';
      d.addEventListener('click', function (e) {
        if (e.target === d || (e.target.closest && e.target.closest('[data-vl-dialog-fermer]'))) {
          if (typeof d.close === 'function') d.close(); else d.removeAttribute('open');
        }
      });
    });
  }

  /* ── Apparition douce des blocs au défilement ── */
  var CIBLES = '.vl-section .vl-entete, .vl-carte, .vl-garantie, .vl-etape, .vl-benefice, .vl-duo__media, .vl-avis, .vl-video-carte, .vl-faq__liste, .nt-trust-section__item, .vl-comparatif__cadre, .vl-hero__texte-bloc, .vl-vitrine';
  var observateurApparition = (!reduireAnimations && 'IntersectionObserver' in window) ? new IntersectionObserver(function (entrees) {
    entrees.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('est-visible'); observateurApparition.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }) : null;
  function initApparitions(portee) {
    if (!observateurApparition) return;
    document.documentElement.classList.add('vl-anim');
    var vus = new Map();
    (portee || document).querySelectorAll(CIBLES).forEach(function (el) {
      if (el.classList.contains('vl-apparition')) return;
      var parent = el.parentElement;
      var rang = vus.get(parent) || 0;
      vus.set(parent, rang + 1);
      el.style.transitionDelay = Math.min(rang, 5) * 90 + 'ms';
      el.classList.add('vl-apparition');
      observateurApparition.observe(el);
    });
    /* filet de sécurité : rien ne reste invisible */
    setTimeout(function () {
      document.querySelectorAll('.vl-apparition:not(.est-visible)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('est-visible');
      });
    }, 1800);
  }

  function tout(portee) {
    var p = portee || document;
    ameliorerAvis(p);
    p.querySelectorAll('[data-vl-offres]').forEach(initOffres);
    p.querySelectorAll('[data-vl-compte]').forEach(initCompte);
    p.querySelectorAll('[data-vl-livraison]').forEach(initLivraison);
    p.querySelectorAll('[data-vl-whatsapp]').forEach(initWhatsapp);
    p.querySelectorAll('[data-vl-aa]').forEach(initAvantApres);
    p.querySelectorAll('[data-vl-faq]').forEach(initFaq);
    p.querySelectorAll('[data-vl-carrousel]').forEach(initCarrousel);
    p.querySelectorAll('[data-vl-video]').forEach(initVideo);
    p.querySelectorAll('[data-vl-barre]').forEach(initBarre);
    initDialogues(p);
    initApparitions(p);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { tout(); });
  else tout();
  document.addEventListener('shopify:section:load', function (e) { tout(e.target); });
})();
